// Explicit CSS-pixel specification supplied by the operator, not image estimates.
export const isNotaTemplate = settings => ['nota1', 'nota3'].includes(settings?.receipt_template);
export function receiptPaperWidth(s = {}) {
  const width = Number(s.custom_paper_width ?? 80);
  return s.paper === 'custom' && Number.isFinite(width) && width >= 40 && width <= 210
    ? width : String(s.paper) === '58' ? 58 : 80;
}

export function notaStyles(template, qtyChars, unitChars) {
  const one = template === 'nota1';
  return `
    #r { font-size:12px; font-weight:400; line-height:1.2; font-synthesis:none; visibility:hidden; }
    #r, #r * { -webkit-text-stroke:0; }
    #r p, #r h1, #r h2, #r h3 { margin:0; padding:0; }
    .big { font-size:15px; font-weight:700; line-height:1.2; margin:0; }
    .address, .phone, .reprint { font-size:11px; line-height:1.2; }
    .reprint { font-weight:${one ? 700 : 400}; }
    .receipt-heading { margin-bottom:2mm; }
    .hr { border:0; border-top:1px ${one ? 'dashed' : 'solid'} #000; margin:1mm 0; padding:0; }
    .sale-meta { margin:0; font-size:12px; font-weight:400; }
    .invoice { margin:0; text-align:center; font-size:12px; font-weight:400; }
    .it { margin:0 0 1.2mm; padding:0; letter-spacing:normal; }
    .it:last-child { margin-bottom:0; }
    .item-name { font-size:12px; font-weight:${one ? 700 : 400}; }
    .item-detail { margin-top:0.5mm; padding:0 0 0 2mm; display:grid;
      grid-template-columns:minmax(0,${qtyChars + 0.2}ch) minmax(0,${unitChars * 1.4}ch) 1ch minmax(0,1fr) minmax(0,1fr);
      column-gap:1mm; align-items:baseline; font-size:12px; font-weight:400; }
    .item-calculation { display:contents; }
    .item-detail span { min-width:0; }
    .item-qty { padding:0; text-align:left; }
    .item-price, .item-amount { text-align:right; overflow-wrap:anywhere; }
    .row { padding:0; font-size:12px; font-weight:400; }
    .total { margin:0; font-size:${one ? 16 : 20}px; font-weight:700; align-items:baseline; }
    .total > span:first-child { white-space:nowrap; flex-shrink:0; }
    .total > span:last-child { min-width:0; overflow-wrap:anywhere; }
    .item-count { margin:0; display:grid; grid-template-columns:max-content max-content; column-gap:2mm; }
    .footer { margin-top:2mm; font-size:12px; font-weight:${one ? 700 : 400}; }
  `;
}

// Preview uses the identical document/CSS but never calls print or afterprint.
// A missing bundled font is an explicit error, never a silently substituted font.
export function notaReadyScript(preview, totalSize) {
  return `<script>window.onload=async function(){
    try {
      if(!document.fonts)throw new Error('Font API tidak tersedia');
      var loaded=await Promise.all([document.fonts.load('400 12px "Roboto Condensed"'),document.fonts.load('700 15px "Roboto Condensed"'),document.fonts.load('700 ${totalSize}px "Roboto Condensed"')]);
      await document.fonts.ready;
      if(loaded.some(function(fonts){return !fonts.length;}))throw new Error('Font tidak tersedia');
      await Promise.all(Array.from(document.images).map(async function(img){try{await img.decode();}catch(e){img.style.display='none';}}));
      document.getElementById('r').style.visibility='visible';document.documentElement.dataset.receiptReady='true';
      ${preview ? '' : "setTimeout(function(){try{window.focus();window.print();}catch(e){if(window.frameElement && window.frameElement.onReceiptPrintError)window.frameElement.onReceiptPrintError();}},150);"}
    } catch(e) {
      document.documentElement.dataset.receiptReady='error';
      var message=document.createElement('p');message.setAttribute('role','alert');message.textContent='Font struk gagal dimuat. Periksa koneksi lalu buka ulang pratinjau/cetak.';document.body.appendChild(message);
      if(window.frameElement && window.frameElement.onReceiptPrintError)window.frameElement.onReceiptPrintError();
    }
  };${preview ? '' : 'window.onafterprint=function(){if(window.frameElement && window.frameElement.onReceiptPrintDone)window.frameElement.onReceiptPrintDone();else window.close();};'}</script>`;
}

// Same deterministic transaction on both sides; never submitted to an API.
export const notaSample = {
  invoice_no:'CONTOH-NOTA', created_at:'2026-09-27T01:58:00+07:00', is_reprint:true,
  items:[
    {name:'KAPAL API MINI',qty:2,price_level:'RCG',price:10000},
    {name:'MAXTEA TEH TARIK',qty:1,price_level:'RCG',price:23000},
    {name:'GG FILTER 12',qty:1,price_level:'BKS',price:30000},
    {name:'MAXTEA TEH TARIK',qty:1,price_level:'PACK',price:112000},
  ],
  subtotal:185000,total:185000,paid:185000,change:0,payments:[{method:'tunai',amount:185000}],
};
